import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Stack, Typography } from "@mui/material";

import { ISOStringToRelativeTime } from "utils";

interface Props {
  shipment: CondensedShipment;
  bookedQuote: CondensedQuote | undefined;
}

export function CarrierView(props: Props) {
  const { shipment, bookedQuote } = props;

  if (!shipment.shipment_creator || !shipment.shipment_company) {
    return null;
  }

  const shipperName = `${shipment.shipment_creator.first_name} ${shipment.shipment_creator.last_name}`;
  const shipperCompanyName = shipment.shipment_company.name;
  const lastLogin = bookedQuote?.opposing_party_last_login;

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Stack direction="column">
        <AccountCircleIcon fontSize="large" color="primary" />
      </Stack>

      <Stack direction="column">
        <Typography variant="h6">{shipperName}</Typography>
        <Typography variant="body1">{shipperCompanyName}</Typography>
        {lastLogin && (
          <Typography variant="caption" color="text.secondary">
            {`Last active ${ISOStringToRelativeTime(lastLogin)}`}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
